import { ChangeDetectionStrategy, Component, EventEmitter, Output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { TenantRequest, tenantAttributes } from '../models/tenant.model';
import { Modal } from '../../../../shared/components/modal/modal';
import { ModalFooterDirective } from '../../../../shared/components/modal/modal-footer.directive';
import { FormField } from '../../../../shared/components/forms/form-field';
import { TextInput } from '../../../../shared/components/forms/text-input';
import { Toggle } from '../../../../shared/components/forms/toggle';

/**
 * Create-tenant form. Domains are entered as a comma-separated list; the
 * field is optional — left empty, `null` is sent instead of an empty array.
 */
@Component({
  selector: 'app-create-tenant-dialog',
  standalone: true,
  imports: [FormsModule, TranslocoDirective, Modal, ModalFooterDirective, FormField, TextInput, Toggle],
  templateUrl: './create-tenant-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateTenantDialogComponent {
  @Output() close = new EventEmitter<void>();
  @Output() save = new EventEmitter<TenantRequest>();

  readonly open = signal(true);

  name = '';
  alias = '';
  description = '';
  domains = '';
  contact = '';
  region = '';
  enabled = true;

  private get domainNames(): string[] {
    return this.domains
      .split(',')
      .map((d) => d.trim())
      .filter((d) => d.length > 0);
  }

  get isValid(): boolean {
    return !!this.name.trim() && !!this.alias.trim();
  }

  onSubmit(): void {
    if (!this.isValid) return;
    const domainNames = this.domainNames;
    this.save.emit({
      name: this.name.trim(),
      alias: this.alias.trim(),
      enabled: this.enabled,
      description: this.description.trim() || undefined,
      domains: domainNames.length > 0 ? domainNames.map((name) => ({ name })) : null,
      attributes: tenantAttributes(this.contact, this.region),
    });
  }

  onClose(): void {
    this.close.emit();
  }
}
